import { render, staticRenderFns } from "./PasswordOnboarding.vue?vue&type=template&id=7a634c80&scoped=true&"
import script from "./PasswordOnboarding.vue?vue&type=script&lang=js&"
export * from "./PasswordOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./PasswordOnboarding.vue?vue&type=style&index=0&id=7a634c80&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a634c80",
  null
  
)

component.options.__file = "PasswordOnboarding.vue"
export default component.exports